import { graphql } from "react-relay";

export const COMMIT_PLAYER_CHANGES = graphql`
  mutation CommitPlayerExposureChangesMutation(
    $input: CommitPlayerExposureChangesInput!
  ) {
    commitPlayerExposureChanges(input: $input) {
      success
    }
  }
`;
